import { NgOptimizedImage } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { DataLayerService } from '../../../../../common/modules/analytics/data-layer.service';
import { AlertModule } from '../../../../../common/modules/bootstrap/alert/alert.module';
import { FontAwesomeDirective } from '../../../../../common/modules/font-awesome/font-awesome.directive';
import { InputPasswordComponent } from '../../../../../common/modules/form/input-password/input-password.component';
import { AuthService } from '../../../../../common/services/auth.service';
import { SessionService } from '../../../../../common/services/session.service';
import { RootComponent } from '../../oneclick-login/root.component';

@Component({
    templateUrl: './login.template.html',
    imports: [
        NgOptimizedImage, ReactiveFormsModule, RouterLink,

        AlertModule, InputPasswordComponent, RootComponent, FontAwesomeDirective,
    ],
})
export class LoginComponent {
    private auth = inject(AuthService);
    private dataLayer = inject(DataLayerService);
    private fb = inject(UntypedFormBuilder);
    private session = inject(SessionService);

    loading = signal<boolean>(false);
    errorMessage = '';
    form = this.fb.group({
        username: ['', Validators.required],
        password: ['', Validators.required],
    });

    onSubmit(): void {
        if (this.form.invalid) {
            return;
        }

        this.loading.set(true);
        this.auth.login({...this.form.value})
            .pipe(take(1))
            .pipe(catchError((error: HttpErrorResponse) => {
                this.loading.set(false);
                this.errorMessage = error.error.message;

                if ('Invalid credentials.' === error.error.message) {
                    this.errorMessage = 'Identifiants invalides.';
                } else if ('Too many failed login attempts, please try again in 15 minutes.' === error.error.message) {
                    this.errorMessage = 'Plusieurs tentatives de connexion ont échoué, veuillez réessayer dans 15 minutes.';
                }

                return EMPTY;
            }))
            .subscribe(() => {
                // @TODO: supprimer ces 2 lignes minimum 2 semaines après la MEP du Design System
                localStorage.removeItem('filters.articles');
                localStorage.removeItem('filters.article-references');

                this.dataLayer.login(this.session.user());
                this.auth.redirectToApp();
            });
    }
}
